import packageJson from "../../../../package.json";

export default function clearCache(): void {
    let version = localStorage.getItem('version');
    
    // Solo borramos caché si la versión cambió
    if (version !== packageJson.version) {
        // Verificamos si el navegador soporta la API de caché
        if ('caches' in window) {
            caches.keys().then((names) => {
                names.forEach(name => {
                    // Eliminamos cada caché almacenado
                    caches.delete(name);
                });
            }).catch(error => {
                console.error('Error al limpiar el caché:', error);
            });
        }

        // Limpiamos solo la clave 'version' en localStorage
        localStorage.removeItem('version');
        // Establecemos la nueva versión en localStorage
        localStorage.setItem('version', packageJson.version);

        // Recargamos la página para aplicar los cambios
        window.location.href = '/';
    }
};